 <h4> Please provide the Email ID associated with your account</h4>

<div class="selet_block">
	<div>
        <form [formGroup]="changePasswordRequestForm" (ngSubmit)="changePasswordRequest()">
        <mat-form-field class="name_input me-2" appearance="outline" floatLabel="always"
        [hideRequiredMarker]="false">
        <mat-label>Email</mat-label>
        <input required style="height: auto;" matInput required type="email" formControlName="email"
        placeholder="Please enter Email ID" (keyup)="validate()" [(ngModel)]="email"/>
        <mat-error *ngIf="changePasswordRequestForm.hasError('required', 'email')">
            Email ID is required
        </mat-error>
        <mat-error *ngIf="changePasswordRequestForm.hasError('pattern', 'email')">
           Please enter valid Email ID
        </mat-error>
        </mat-form-field>
        </form>
	</div>
	<div class="select_block_action float-end">
        <button mat-button class="action_btn_no-border" (click)="closeCancel()">Cancel</button>
		<button mat-button class="action_btn_no-border" [disabled]="!isValid"
			(click)="changePasswordRequest()">Ok</button>
    	</div>
</div>
